module.exports = __webpack_public_path__ + "img/partners1.81b34d2f.png";